import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";

export default function NotFound() {
    const overlayRef = useRef(null);

    useEffect(() => {
        const overlay = overlayRef.current;

        let mouseX = window.innerWidth / 2;
        let mouseY = window.innerHeight / 2;

        let currentX = mouseX;
        let currentY = mouseY;

        let radius =
            window.innerWidth < 640
                ? 100
                : window.innerWidth < 1024
                    ? 140
                    : 180;

        const animate = () => {
            currentX += (mouseX - currentX) * 0.08;
            currentY += (mouseY - currentY) * 0.08;

            const pos = `${currentX}px ${currentY}px`;

            overlay.style.maskImage = `radial-gradient(circle ${radius}px at ${pos}, transparent 0%, black ${radius + 90
                }px)`;
            overlay.style.webkitMaskImage = overlay.style.maskImage;

            requestAnimationFrame(animate);
        };

        const handleMouseMove = (e) => {
            mouseX = e.clientX;
            mouseY = e.clientY;
        };

        const handleTouchMove = (e) => {
            mouseX = e.touches[0].clientX;
            mouseY = e.touches[0].clientY;
        };

        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("touchmove", handleTouchMove);

        animate();

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("touchmove", handleTouchMove);
        };
    }, []);

    return (
        <div className="relative w-full min-h-[100svh] bg-gray-950 text-white overflow-hidden">

            {/* Orange Glow Background */}
            <div className="absolute top-10 left-5 sm:left-10 w-40 sm:w-64 lg:w-80 h-40 sm:h-64 lg:h-80 bg-[#ff6900] opacity-30 rounded-full blur-3xl animate-pulse"></div>
            <div className="absolute bottom-10 right-5 sm:right-10 w-40 sm:w-64 lg:w-80 h-40 sm:h-64 lg:h-80 bg-[#ff6900] opacity-20 rounded-full blur-3xl animate-pulse"></div>

            {/* Main Content */}
            <div className="absolute inset-0 flex flex-col items-center justify-center z-10 text-center px-6">

                <h1 className="text-5xl sm:text-6xl md:text-7xl lg:text-8xl font-extrabold mb-4 sm:mb-6 animate-bounce">
                    <span className="text-[#ff6900]">404</span>
                </h1>

                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-3 sm:mb-4">
                    Page Not Found
                </h2>

                <p className="text-sm sm:text-base md:text-lg text-gray-300 max-w-xs sm:max-w-md">
                    The page you’re looking for doesn’t exist or has been moved.
                </p>

                <Link
                    to="/"
                    className="mt-6 sm:mt-8 px-6 py-3 bg-[#ff6900] hover:bg-[#e65f00] transition-all duration-300 rounded-lg shadow-lg hover:scale-105 active:scale-95 text-sm sm:text-base font-medium"
                >
                    Go Home
                </Link>
            </div>

            {/* Spotlight Overlay */}
            <div
                ref={overlayRef}
                className="absolute inset-0 bg-black z-20 pointer-events-none"
            ></div>
        </div>
    );
}